import { ProjectResponseSendComponentProps } from './project-response-renderer.type';
import ProjectResponseSelectSendButtonDesktop from './project-response-select-send-button-desktop';
import ProjectResponseSelectSendButtonMobile from './project-response-select-send-button-mobile';

export default function ProjectResponseSelectSendButton({
  onSubmit,
  disabled,
  isSubmitting,
  renderMobileView,
  type,
  isUserVoiceEnabled,
}: ProjectResponseSendComponentProps) {
  return (
    <>
      <ProjectResponseSelectSendButtonDesktop
        onSubmit={onSubmit}
        disabled={disabled}
        isSubmitting={isSubmitting}
        renderMobileView={renderMobileView}
        type={type}
        isUserVoiceEnabled={isUserVoiceEnabled}
      />

      <ProjectResponseSelectSendButtonMobile
        onSubmit={onSubmit}
        disabled={disabled}
        isSubmitting={isSubmitting}
        renderMobileView={renderMobileView}
        type={type}
        isUserVoiceEnabled={isUserVoiceEnabled}
      />
    </>
  );
}
